<template>
    <div class="locale-changer">
        <span>{{ betterLocale }}</span>
        <select v-model="$i18n.locale" @change="handleChange">
            <option v-for="locale in $i18n.availableLocales" :key="`locale-${locale}`" :value="locale">{{ $t('locale.' + locale) }}</option>
        </select>
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue';
    import { useI18n } from "vue-i18n";

    export default defineComponent({
        setup: () => {
            const betterLocale = ref(useI18n().locale.value);

            const handleChange = (a: FocusEvent) => {
                const target: HTMLSelectElement = a.target as HTMLSelectElement;
                betterLocale.value = target.options[target.selectedIndex].value;
            };

            return {
                handleChange,
                betterLocale
            };
        }
    });
</script>
